/* Cart drawer features (upsell carousel, size sheet, GA4, a11y announce).
   Extracted from the inline <script> in snippets/header-actions.liquid so it loads
   `defer` (non-blocking) and is browser-cached across pages. Pure JS, no Liquid —
   i18n/config comes from data-* attributes on #cart-upsell-zone. */
(function () {
  'use strict';
  var lastAddedProductId = null;

  // Capture product being added (capture phase, before Horizon processes it)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.action) return;
    if (form.action.indexOf('/cart/add') === -1) return;
    var idInput = form.querySelector('input[name="id"]');
    if (idInput) lastAddedProductId = idInput.value; // variant_id; resolved below
  }, true);

  // Load upsell section — on cart change AND when the drawer opens (icon click).
  // Debounced + AbortController: the drawer fires open + cart:update near-simultaneously,
  // so coalesce rapid calls and cancel stale in-flight fetches (no flicker / wrong recs).
  var _upsellTimer = null;
  var _upsellAbort = null;
  function loadCartUpsell() {
    clearTimeout(_upsellTimer);
    _upsellTimer = setTimeout(function () {
      if (_upsellAbort) _upsellAbort.abort();
      _upsellAbort = new AbortController();
      _doLoadCartUpsell(_upsellAbort.signal);
    }, 80);
  }
  function _doLoadCartUpsell(signal) {
    var zone = document.getElementById('cart-upsell-zone');
    if (!zone) return;

    fetch('/cart.js', { signal: signal })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        if (items.length === 0) { zone.hidden = true; return; }

        // Resolve product_id: prefer lastAdded match, fallback to first item
        var productId = null;
        if (lastAddedProductId) {
          var vid = String(lastAddedProductId);
          var match = items.find(function (i) { return String(i.variant_id) === vid; });
          if (match) productId = match.product_id;
        }
        if (!productId) productId = items[0].product_id;
        lastAddedProductId = null;

        var inCartProductIds = items.map(function (i) { return String(i.product_id); });

        var url = (Shopify.routes.root || '/') + 'recommendations/products?section_id=added-cross-sell-onne&product_id=' + productId + '&intent=related&limit=10';
        return fetch(url, { signal: signal })
          .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
          .then(function (html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');
            // Section rendering wraps content in <div id="shopify-section-*">
            var sectionDiv = doc.querySelector('[id^="shopify-section-"]') || doc.body;
            // Exclude products already in the cart (any color) — no point recommending
            // something the customer already added.
            var cards = Array.prototype.filter.call(
              sectionDiv.querySelectorAll('.atc-xs'),
              function (c) {
                var pid = c.getAttribute('data-product-id');
                return !pid || inCartProductIds.indexOf(pid) === -1;
              }
            );
            if (cards.length === 0) { zone.hidden = true; return; }
            if (signal && signal.aborted) return; // a newer load superseded this one

            // Collapsed globe (header + chevron) with a single-row horizontal carousel.
            zone.innerHTML = '';
            var toggle = document.createElement('button');
            toggle.type = 'button';
            toggle.className = 'cart-upsell__toggle';
            toggle.setAttribute('aria-expanded', 'false');
            var upTitle = zone.getAttribute('data-title') || 'You might also like';
            toggle.innerHTML = '<span class="cart-upsell__label">' + upTitle + ' <span class="cart-upsell__count" aria-hidden="true">' + cards.length + '</span></span><span class="cart-upsell__chev" aria-hidden="true">⌄</span>';
            var track = document.createElement('div');
            track.className = 'cart-upsell__track';
            cards.forEach(function (c) {
              // Scuffers-style: move the add control onto the image as a "+" overlay
              // (the size <select> stays in the form, hidden but with its default value).
              var imgWrap = c.querySelector('.atc-xs__img-wrap');
              var form = c.querySelector('.atc-xs__form');
              if (imgWrap && form) imgWrap.appendChild(form);
              track.appendChild(c);
            });
            zone.appendChild(toggle);
            zone.appendChild(track);
            // Expanded by default for small carts (now that capsules are uniform/compact,
            // 3 fits expanded); collapsed for 4+ so it doesn't crowd the products.
            if (items.length >= 4) {
              zone.setAttribute('data-collapsed', '');
              toggle.setAttribute('aria-expanded', 'false');
            } else {
              zone.removeAttribute('data-collapsed');
              toggle.setAttribute('aria-expanded', 'true');
            }
            zone.hidden = false;
          });
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return; // superseded by a newer load, not a real error
        console.warn('[cart-upsell]', err);
        var zone2 = document.getElementById('cart-upsell-zone');
        if (zone2) zone2.hidden = true;
      });
  }
  document.addEventListener('cart:update', loadCartUpsell);
  document.addEventListener('onne:cart-drawer:open', loadCartUpsell);

  // ── GA4 (Task 7): cart_drawer_open + cart_drawer_checkout_click.
  // We do NOT re-instrument add_to_cart — Shopify already emits it natively.
  function ga4(name, params) {
    try {
      if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, params || {}));
    } catch (e) {}
  }
  // Guard: bind the GA4 listeners only once (the inline script can re-run on
  // section re-render / theme-dev hot reload, which would double-fire events).
  if (!window.__onneCartGa4Bound) {
    window.__onneCartGa4Bound = true;
    var lastDrawerOpenFire = 0;
    document.addEventListener('onne:cart-drawer:open', function () {
      var now = +new Date();
      if (now - lastDrawerOpenFire < 1000) return; // dedupe multiple open signals
      lastDrawerOpenFire = now;
      ga4('cart_drawer_open');
    });
    document.addEventListener('click', function (e) {
      var ck = e.target.closest('.cart__checkout-button, button[name="checkout"]');
      // Only the DRAWER's checkout — the /cart page shares .cart__checkout-button but is a
      // separate funnel, so we don't want it firing the drawer event.
      if (ck && ck.closest('.cart-drawer, cart-drawer-component')) {
        ga4('cart_drawer_checkout_click');
      }
    });
  }

  // Expand/collapse the upsell carousel (collapsed by default)
  document.addEventListener('click', function (e) {
    var t = e.target.closest('.cart-upsell__toggle');
    if (!t) return;
    var z = document.getElementById('cart-upsell-zone');
    if (!z) return;
    if (z.hasAttribute('data-collapsed')) {
      z.removeAttribute('data-collapsed');
      t.setAttribute('aria-expanded', 'true');
    } else {
      z.setAttribute('data-collapsed', '');
      t.setAttribute('aria-expanded', 'false');
    }
  });

  // "+" on a carousel card → open the size sheet (Scuffers pattern). The size options
  // are already filtered to the SHOWN color (pairings: partner color; recs: feat color),
  // so adding any of them lands the right color+size as a new cart line.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-atc-xs-add]');
    if (!btn) return;
    e.preventDefault();
    openSizeSheet(btn.closest('.atc-xs'), btn);
  });

  // Bottom sheet: a body-level <dialog> showModal() so it lives in the top layer ABOVE
  // the cart's modal dialog and is immune to the cart Section-Rendering morph.
  function ensureSizeSheet() {
    var dlg = document.getElementById('cart-size-sheet');
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.id = 'cart-size-sheet';
    dlg.className = 'cart-size-sheet';
    dlg.innerHTML =
      '<div class="cart-size-sheet__panel" role="document">' +
        '<button type="button" class="cart-size-sheet__close" data-css-close aria-label="Close">' +
          '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<div class="cart-size-sheet__head">' +
          '<img class="cart-size-sheet__img" alt="" width="56" height="72">' +
          '<div class="cart-size-sheet__meta"><p class="cart-size-sheet__title"></p><p class="cart-size-sheet__sub"></p></div>' +
        '</div>' +
        '<p class="cart-size-sheet__label"></p>' +
        '<div class="cart-size-sheet__sizes"></div>' +
      '</div>';
    document.body.appendChild(dlg);
    // Close on backdrop (click outside the panel) and on the X.
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-css-close]')) dlg.close();
    });
    // Size pick → add that exact variant (color+size) as a new cart line.
    dlg.addEventListener('click', function (e) {
      var opt = e.target.closest('.cart-size-opt[data-vid]');
      if (!opt || opt.disabled) return;
      addVariantToCart(opt.getAttribute('data-vid'), opt, dlg);
    });
    return dlg;
  }

  function openSizeSheet(card, btn) {
    if (!card) return;
    var zone = document.getElementById('cart-upsell-zone');
    var chooseLbl = (zone && zone.getAttribute('data-choose-size')) || 'Select your size';
    var oneSizeLbl = (zone && zone.getAttribute('data-one-size')) || 'One size';

    var titleEl = card.querySelector('.atc-xs__title');
    var imgEl = card.querySelector('.atc-xs__img');
    var priceEl = card.querySelector('.atc-xs__price');
    var color = card.getAttribute('data-color') || '';
    var sel = card.querySelector('[data-atc-xs-size]');

    var opts = [];
    if (sel && sel.options.length) {
      Array.prototype.forEach.call(sel.options, function (o) {
        opts.push({ id: o.value, label: (o.textContent || '').trim(), disabled: o.disabled });
      });
    } else if (btn && btn.dataset.variant) {
      opts.push({ id: btn.dataset.variant, label: oneSizeLbl, disabled: false });
    }
    if (!opts.length) return;

    var dlg = ensureSizeSheet();
    dlg.querySelector('.cart-size-sheet__img').src = imgEl ? (imgEl.currentSrc || imgEl.src) : '';
    dlg.querySelector('.cart-size-sheet__title').textContent = titleEl ? titleEl.textContent.trim() : '';
    var sub = [];
    if (color) sub.push(color);
    if (priceEl) sub.push(priceEl.textContent.trim());
    dlg.querySelector('.cart-size-sheet__sub').textContent = sub.join(' · ');
    // Single one-size variant → no "select your size" prompt needed.
    dlg.querySelector('.cart-size-sheet__label').textContent = (opts.length === 1 && !sel) ? '' : chooseLbl;

    var wrap = dlg.querySelector('.cart-size-sheet__sizes');
    wrap.innerHTML = '';
    opts.forEach(function (o) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'cart-size-opt';
      b.textContent = o.label;
      if (o.disabled) b.disabled = true;
      else b.setAttribute('data-vid', o.id);
      wrap.appendChild(b);
    });
    dlg.showModal();
  }

  var _addInFlight = false;
  function addVariantToCart(vid, optBtn, dlg) {
    if (_addInFlight) return; // ignore rapid double-tap → never adds 2 units of the same variant
    _addInFlight = true;
    optBtn.disabled = true;
    optBtn.setAttribute('aria-busy', 'true');
    optBtn.classList.add('is-loading');
    // Add WITH the cart section so the response carries its HTML — Horizon's
    // cart-items-component listens to 'cart:update' and reads event.detail.data.sections
    // to morph the new line in. (A bare detail:{} threw on .data → item added server-side
    // but the drawer didn't refresh until reload.)
    var cic = document.querySelector('cart-items-component');
    var sectionId = cic && cic.dataset.sectionId;
    var body = { id: Number(vid), quantity: 1 };
    if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed ' + r.status);
        return r.json();
      })
      .then(function (data) {
        // detail.data must be an object: if it has sections[sectionId] Horizon morphs it,
        // otherwise it falls back to re-fetching the section — either way the drawer refreshes.
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: data, source: 'cart-size-sheet' }
        }));
        announceCart(true);
        dlg.close();
        _addInFlight = false;
      })
      .catch(function (err) {
        console.warn('[size-sheet]', err);
        optBtn.disabled = false;
        optBtn.removeAttribute('aria-busy');
        optBtn.classList.remove('is-loading');
        announceCart(false);
        _addInFlight = false;
      });
  }

  // SR-only live region for cart add success/error (created once on <body>).
  function announceCart(ok) {
    var zone = document.getElementById('cart-upsell-zone');
    var msg = zone ? (ok ? zone.getAttribute('data-msg-success') : zone.getAttribute('data-msg-error')) : '';
    if (!msg) msg = ok ? 'Added to cart' : "Couldn't add — please try again";
    var live = document.getElementById('cart-aria-live');
    if (!live) {
      live = document.createElement('div');
      live.id = 'cart-aria-live';
      live.setAttribute('role', 'status');
      live.setAttribute('aria-live', 'assertive');
      live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;';
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 30);
  }
})();
